import { render, staticRenderFns } from "./SimpleMap.ts.vue?vue&type=template&id=b1051c94&"
import script from "./SimpleMap.ts.vue?vue&type=script&lang=ts&"
export * from "./SimpleMap.ts.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleMap.ts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports